import { render, staticRenderFns } from "./BannerTable.vue?vue&type=template&id=884d0c2c&"
import script from "./BannerTable.vue?vue&type=script&lang=js&"
export * from "./BannerTable.vue?vue&type=script&lang=js&"
import style0 from "./BannerTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports